import React, { useMemo, useState } from "react";
import { Select } from "@mantine/core";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const toSelectData = (items = []) =>
  items.map((item) => ({
    value: item.value,
    label: item.label,
  }));

const mergeTypeOptions = (items, value) => {
  const data = toSelectData(items);
  if (!value || data.some((item) => item.value === value)) return data;
  return [{ value, label: value }, ...data];
};

const CreatableTypeSelect = ({
  form,
  name,
  label,
  items = [],
  required = false,
  disabled = false,
  placeholder,
  ...props
}) => {
  const { t } = useTranslation();
  const currentValue = _.get(form.values, name) ?? null;
  const [extraOptions, setExtraOptions] = useState([]);

  const data = useMemo(() => {
    const base = mergeTypeOptions(items, currentValue);
    const merged = [...base];
    extraOptions.forEach((option) => {
      if (!merged.some((item) => item.value === option.value)) {
        merged.push(option);
      }
    });
    return merged.map((item) => ({
      value: item.value,
      label: t(item.label),
    }));
  }, [items, currentValue, extraOptions, t]);

  const inputProps = form.getInputProps(name);

  return (
    <Select
      label={label ? t(label) : undefined}
      placeholder={placeholder}
      required={required}
      disabled={disabled}
      searchable
      clearable
      creatable
      data={data}
      getCreateLabel={(query) =>
        t("Add type: {{name}}", { name: query.trim() })
      }
      onCreate={(query) => {
        const value = query.trim().toLowerCase().replace(/\s+/g, "");
        if (!value) return null;
        const option = { value, label: query.trim() };
        setExtraOptions((current) => [...current, option]);
        return value;
      }}
      withinPortal
      zIndex={1000}
      {...inputProps}
      {...props}
    />
  );
};

export default CreatableTypeSelect;
